import { tokens } from './tokens';
import { recipes, slotRecipes } from './recipes';
import { semanticTokens } from './semanticTokens';

import {
  createSystem,
  defaultConfig,
  defineConfig,
  mergeConfigs,
} from '@chakra-ui/react';

const lightTheme = {
  tokens,
  recipes,
  slotRecipes,
  semanticTokens,
};

const customConfig = defineConfig({
  theme: lightTheme,
  strictTokens: true,
});

const config = mergeConfigs(defaultConfig, customConfig);
const system = createSystem(config);

export default system;
